import Input from "../../form/Input";
import FileUploadSingle from "../../form/FileUploadSingle";
import useForm from "../../../hooks/useForm";
import { useEffect, useState } from "react";
import { formatBytes } from "../../../helpers";
import Button from "../../form/Button";
import useMutation from "../../../hooks/useMutation";

const validation = {
  message: { required: true, message: "Cant't send empty message" },
};

export default function ChatInput({
  sendMessageHandler = async () => {},
  uploadProgress,
}) {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
    updateErrors,
    resetField,
  } = useForm({ validationRules: validation });
  const [isImage, setIsImage] = useState(false);
  const [uploadProgressCount, setUploadProgressCount] = useState(0);

  useEffect(() => {
    if (values?.attachment) {
      delete validation.message;
      delete errors.message;
      updateErrors(errors);
    } else if (!values?.attachment && !values?.messaage) {
      validation["message"] = {
        required: true,
        message: "Cant't send empty message",
      };
    }
  }, [values]);

  useEffect(() => {
    if (values?.attachment?.type) {
      setIsImage(values?.attachment?.type?.split("/")[0] === "image");
    }
  }, [values?.attachment?.type]);

  const { mutate: onReply, isPending } = useMutation({
    mutationFn: async (val) => {
      const res = await sendMessageHandler({
        val,
        uploadProgress: setUploadProgressCount,
      });
      if (res?.status === 200) {
        setUploadProgressCount(0);
      }
      return res;
    },
    onSuccess: (res) => {
      if (res?.status === 200) {
        setFieldsValue({ attachment: null, message: "" });
      }
    },
    onError: (err) => {
      console.log(err);
    },
  });

  return (
    <form onSubmit={(e) => handleSubmit(e, onReply)}>
      <div className="p-4 border-t bg-white flex items-center gap-x-1">
        {!values?.attachment && (
          <div className="w-10 h-10 relative overflow-hidden">
            <div className="absolute w-full h-full flex items-center justify-center left-0 top-0 bg-slate-100 rounded">
              <i class="fa-light fa-paperclip"></i>
            </div>
            <div className="opacity-0 absolute top-0 left-0 w-full h-full">
              <FileUploadSingle
                bodyClass="p-0"
                inputClass=""
                labelClass="w-full h-full"
                size="small"
                value={values?.attachment}
                placeholder=""
                onChange={(file) =>
                  handleChange({
                    target: {
                      name: "attachment",
                      value: file,
                    },
                  })
                }
                // {...formValidate(errors, "attachment")}
              />
            </div>
          </div>
        )}
        <div className="h-fit rounded-md placeholder:text-shades-07 bg-white border border-shades-05/50 px-3 font-CanelaDeck text-sm text-gable-green !ring-0 !outline-0 focus:border-shades-07 transition-all duration-200 w-full divide-y">
          {values?.attachment && (
            <div className="bg-chestnut-rose/5 mb-3 w-36 h-fit mt-2 rounded-lg overflow-hidden relative">
              <div className="h-28 w-full p-2">
                <img
                  src={
                    isImage
                      ? URL.createObjectURL(values?.attachment)
                      : require("../../../assets/images/folder.png")
                  }
                  alt="attachment"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="px-2 pb-2">
                <div className="text-xs font-normal w-full truncate">
                  {values?.attachment?.name}
                </div>
                <div className="text-xs font-normal w-full divide-x flex items-center">
                  <span className="flex pr-2 items-center whitespace-nowrap">
                    {formatBytes(values?.attachment?.size)}
                  </span>
                  <span className="flex pl-2 items-center whitespace-nowrap">
                    {values?.attachment?.type?.split("/").at(-1)}
                  </span>
                </div>
              </div>
              {!isPending && (
                <Button
                  buttonIconPosition={"left"}
                  buttonIcon={"fa-fw fa-regular fa-xmark text-[10px]"}
                  buttonClasses={"w-6 !h-6 !rounded !absolute top-1 right-1"}
                  buttonFunction={() => {
                    setFieldsValue({ attachment: null });
                  }}
                />
              )}
              {uploadProgressCount > 0 && (
                <div className="absolute top-0 left-0 w-full h-full bg-chestnut-rose/40 flex items-center justify-center text-white">
                  <div className="relative">
                    <i className="fa-fw fa-duotone fa-solid fa-spinner-third animate-spin text-6xl"></i>
                    <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center text-[15px] font-semibold">
                      {uploadProgressCount}%
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          <Input
            value={values?.message}
            onChange={handleChange}
            inputName={"message"}
            inputPlaceholder={"Type your message"}
            inputClasses={"!border-0"}
            // {...formValidate(errors, "message")}
          />
        </div>
        {(values?.message || values?.attachment) && (
          <Button
            buttonIconPosition={"left"}
            buttonIcon={"fa-fw fa-regular fa-paper-plane-top"}
            buttonClasses={"w-10 !h-10 ml-3 mt-auto"}
            buttonType="submit"
            {...(isPending && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
        )}
      </div>
    </form>
  );
}
